import * as angular from 'angular';
class ContentAdvancedConfigurationController {
    static $inject = ['ModalService', 'TranslateService', '$scope', '$timeout'];
    constructor(ModalService, TranslateService, $scope, $timeout) {
        'ngInject';
        this.$onInit = () => { };
        /* Can be: 'initial' or 'editing' */
        this.STATE = 'initial';
        this._modalService = ModalService;
        this._$scope = $scope;
        this._$timeout = $timeout;
    }
    editItem(item) {
        this.STATE = 'editing';
        this.editingItem = angular.copy(item);
    }
    cancelEdit() {
        this._reset();
    }
    $saveModel() {
        if (!this.editingItem || this.configurationForm.$invalid) {
            return;
        }
        this.data = this.editingItem;
        this.onSave({ $configuration: this.data });
        this._reset();
    }
    $deleteModel() {
        this.onDelete({ $configuration: this.data });
        this._reset();
    }
    _reset() {
        this.STATE = 'initial';
        this.editingItem = undefined;
    }
}
ContentAdvancedConfigurationController.$inject = ['ModalService', 'TranslateService', '$scope', '$timeout'];
export default ContentAdvancedConfigurationController;
